module.exports = __webpack_public_path__ + "static/NH-8ca0a5923d08384f614bdf803f0f1afe.svg";